<div class="p8-bdc_page__content-container mat-typography" *ngIf="page">
  <div class="p8-bdc_page__columns-container" fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center">
    <div class="p8-bdc_page__article-container p8-justify" fxFlex>
      <div fxLayoutAlign="end"><a (click)="close()" matTooltip="Fermer la fenêtre" style="cursor: pointer;"><mat-icon>close</mat-icon></a></div>
      <div class="p8-bdc_page__title-container">
        <div class="mat-headline">{{ page.title }}</div>
        <div class="mat-caption p8-secondary">Dernière modification le {{ page.dt_updated | date:'dd/MM/yyyy' }}</div>
        <mat-divider></mat-divider>
      </div>
      <div class="p8-bdc_page-preview__page-container">
        <p8-bdc-page-content [content]="page?.content?.body"></p8-bdc-page-content>
        <p8-bdc-document *ngIf="page.documents_obj && page.documents_obj.length > 0" [documents]="page.documents_obj"></p8-bdc-document>
      </div>
    </div>
  </div>
</div>
